
import {Component, Vue} from "vue-property-decorator";
import {clearAll} from "../api/cache";
import {store} from '../Store';

@Component
export default class BackArrow extends Vue {
    data = store.data;
    press() {
        if (this.data.searchingMode) {
            store.toggleSearchingMode();
            return;
        }
        this.$router.push({path: '/'});
    }
}
